module.exports = __webpack_public_path__ + "static/media/ringtone.60a3298f.mp3";